<template>
    <div class="min-h-screen bg-gradient-to-b from-gray-800 to-gray-900">
      <!-- Header -->
      <header class="w-full px-[12.5%] py-6 backdrop-blur-sm bg-gray-800/50 border-b border-gray-700">
        <div class="max-w-6xl mx-auto flex justify-between items-center">
          <router-link to="/blog/1" class="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-cyan-300">
            My Blog
          </router-link>
          
        </div>
      </header>
  
      <!-- Main Content -->
      <main class="w-full px-[12.5%] py-12">
        <div class="max-w-4xl mx-auto">
          <!-- Back Button -->
          <button 
            @click="$router.go(-1)" 
            class="mb-8 flex items-center text-gray-400 hover:text-blue-300 transition-colors group"
          >
            <span class="group-hover:-translate-x-1 transition-transform">←</span>
            <span class="ml-2" @click="returnToBlog">Back to articles</span>
          </button>
  
          <!-- Article Header -->
          <div class="mb-12 animate-fade-in">
            <div class="flex items-center gap-3 mb-6">
              <div class="w-10 h-10 rounded-full bg-gradient-to-r from-blue-500 to-cyan-400 flex items-center justify-center text-white">
                {{ getCategoryEmoji(post.category) }}
              </div>
              <span class="text-sm text-gray-400">{{ formatDate(post.date) }}</span>
            </div>
            
            <h1 class="text-4xl sm:text-5xl font-bold text-white mb-6 leading-tight">
              {{ post.title }}
            </h1>
            
            <div class="flex flex-wrap gap-3">
              <span class="px-3 py-1 rounded-full text-sm font-medium bg-gray-700/50 text-gray-300">
                {{ post.category }}
              </span>
              <span 
                v-for="tag in post.tags" 
                :key="tag"
                class="px-3 py-1 rounded-full text-sm font-medium bg-gray-700/50 text-gray-300"
              >
                {{ tag }}
              </span>
            </div>
          </div>
  
          <!-- Featured Image -->
          <div 
            v-if="post.featuredImage" 
            class="mb-12 rounded-2xl overflow-hidden border border-gray-700"
          >
            <img 
              :src="getImage(post.featuredImage)" 
              :alt="post.title" 
              class="w-full h-auto object-cover"
            >
          </div>
  
          <!-- Article Content -->
          <article class="prose prose-invert max-w-none mb-16 animate-fade-in">
            <!-- This would be your dynamic content from a CMS or markdown file -->
            <div   ref="postContentContainer"  v-html="post.content"     class="custom-html  [&_h1]:text-3xl [&_h1]:font-bold [&_h1]:mb-6 [&_h1]:text-white"></div>
            
            
            

            
            <div class="my-8 p-6 mt-24 bg-gray-800/50 rounded-xl border border-gray-700">
              <h3 class="text-lg font-semibold text-blue-300 mb-3">Key Takeaway</h3>
              <p  ref="takeAwayContainer"  class="text-gray-300" v-html="post.takeAway">
              </p>
            </div>
            
            
          </article>
  
          <!-- Author Bio -->
          <div class="mt-16 pt-8 border-t border-gray-700">
        <div class="flex items-start gap-6">
          <!-- Avatar Container -->
          <div class="shrink-0 relative w-16 h-16">
            <img 
              :src="require('../assets/Gallery/ai9.png')" 
              alt="Author" 
              class="absolute inset-0 w-full h-full rounded-full border-2 border-cyan-400/30 hover:border-cyan-400/60 transition-all duration-300 object-cover object-center"
            >
          </div>
          
          <div>
                <h3 class="text-xl font-bold text-white mb-2">About the Author</h3>
                <p class="text-gray-400">
                  Hi, I'm Hédi. I made AI witness over the corrupt people we have around us. A bunch of metal and silicon glued together munching on electrons, speaks the truth and denounces the corrupt system we're living in. Shouldn't you as well get out of darkness?</p>
              </div>
            </div>
          </div>
  
          <!-- Related Posts -->
          <div class="mt-24">
            <h2 class="text-2xl font-bold text-white mb-8">More like this</h2>
            <div class="grid md:grid-cols-2 gap-6">
              <div 
                v-for="related in relatedPosts" 
                :key="related.id"
                @click="$router.push(`/posts/${related.id}`)"
                class="group cursor-pointer p-6 rounded-2xl bg-gray-800/50 backdrop-blur-sm border border-gray-700 hover:border-blue-400/30 transition-all duration-300"
              >
                <div class="flex items-center gap-3 mb-3">
                  <div class="w-8 h-8 rounded-full bg-gradient-to-r from-blue-500 to-cyan-400 flex items-center justify-center text-white text-sm">
                    {{ getCategoryEmoji(related.category) }}
                  </div>
                  <span class="text-sm text-gray-400">{{ formatRelativeDate(related.date) }}</span>
                </div>
                <h3 class="text-xl font-bold text-white group-hover:text-blue-300 transition-colors mb-2">
                  {{ related.title }}
                </h3>
                <p class="text-gray-400 line-clamp-2" v-html="related.takeAway"></p>
              </div>
            </div>
          </div>
        </div>
      </main>
  
      <!-- Footer -->
      <footer class="w-full px-[12.5%] py-12 border-t border-gray-800 bg-gray-900/50">
        <div class="max-w-6xl mx-auto">
          <div class="flex flex-col md:flex-row justify-between items-center">
            <div class="mb-6 md:mb-0">
              <h2 class="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-cyan-300 mb-2">
                My Blog
              </h2>
              <p class="text-gray-400">While many articles here are generally AI-generated content, what makes this blog unique is my human curation and refinement process. I carefully select thought-provoking topics, and ensure each piece delivers genuinely valuable insights - saving you time while sparking your curiosity with quality distilled information.</p>
            </div>
            <div class="flex gap-4">
              <a href="#" class="text-gray-400 hover:text-blue-300 transition-colors">
                <span class="sr-only">Twitter</span>
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
              </a>
              <a href="#" class="text-gray-400 hover:text-blue-300 transition-colors">
                <span class="sr-only">GitHub</span>
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clip-rule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
          <div class="mt-8 pt-8 border-t border-gray-800 text-center text-gray-500 text-sm">
            © 2023 My Blog. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  </template>
  
  <script setup>
  import { ref, computed, onMounted, nextTick, watch  } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import posts from '@/assets/Posts/blogPosts'
  import renderMathInElement from 'katex/contrib/auto-render';
  import 'katex/dist/katex.min.css'; // Ensure CSS is loaded (can also be in main.js)


  // Get the route object
  const route = useRoute()
  const router = useRouter()
  const id = route.params.id

// Access the id parameter
const getImage = (name) => {
  try {
    return require(`@/assets/blog/${name}`);
  } catch {
    try {
      return require(`@/assets/blog/${name}`);
    } catch {
      return require(`@/assets/Gallery/default.png`);
    }
  }
};
const postContentContainer = ref(null);
const takeAwayContainer = ref(null); // <-- ADD THIS LINE

  const post = ref({})
  // Function to render math using KaTeX
// Function to render math using KaTeX
const renderMath = () => {
  nextTick(() => {
    const katexOptions = {
      delimiters: [
        { left: '$$', right: '$$', display: true },
        { left: '\\[', right: '\\]', display: true },
        { left: '$', right: '$', display: false },
        { left: '\\(', right: '\\)', display: false }
      ],
      throwOnError: false
    };

    // Render in main content
    if (postContentContainer.value) {
      console.log("Attempting to render math in main content:", postContentContainer.value);
      try {
        renderMathInElement(postContentContainer.value, katexOptions);
        console.log("KaTeX render attempted on main content.");
      } catch (error) {
        console.error("KaTeX rendering error in main content:", error);
      }
    } else {
      console.warn("postContentContainer ref not found for KaTeX.");
    }

    // --- ADD THIS PART ---
    // Render in takeaways content
    if (takeAwayContainer.value) {
      console.log("Attempting to render math in takeaways:", takeAwayContainer.value);
       try {
         renderMathInElement(takeAwayContainer.value, katexOptions);
         console.log("KaTeX render attempted on takeaways.");
       } catch (error) {
         console.error("KaTeX rendering error in takeaways:", error);
       }
    }
    // No warning needed if takeaways ref isn't found, as it might be optional
    // --- END OF ADDITION ---

  });
};


watch(post, (newPost) => {
  if (newPost) {
    console.log("Post data changed, calling renderMath."); // Debug log
    renderMath(); // Re-render math when content updates
  }
}, { immediate: false }); 

  // Find the current post based on route params
  onMounted(() => {
    const postId = route.params.id
    const foundPost = posts.find(p => p.id === postId) || posts[0]
    post.value = foundPost;
    if (post.value) {
    renderMath();
    }
  })
  
  // Get related posts (excluding current)
  const relatedPosts = computed(() => {
    return posts
      .filter(p => p.id !== post.value.id && p.category === post.value.category)
      .slice(0, 2)
  })
  
  // Helper functions (same as in your listing component)
  function getCategoryEmoji(category) {
    const emojis = {
      'Dev': '💻',
      'Islam': '🕌',
      'Art': '🎨',
      'Relationships': '💞',
      'Maths': '🧮',
      'Physics': '⚛️',
      'Medicine': '🩺',
      'Bodybuilding': '💪'
    }
    return emojis[category] || '✍️'
  }
  
  function formatDate(dateString) {
    return new Date(dateString).toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    })
  }

  function returnToBlog() {
    const currentPage = localStorage.getItem('blogPage')
    if (currentPage) {
     router.replace('/blog/' + currentPage)
   }
  }
  
  function formatRelativeDate(dateString) {
    const date = new Date(dateString)
    const now = new Date()
    const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24))
    
    if (diffDays === 0) return 'Today'
    if (diffDays === 1) return 'Yesterday'
    if (diffDays < 7) return `${diffDays} days ago`
    if (diffDays < 30) return `${Math.floor(diffDays/7)} weeks ago`
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  }
  
  const darkMode = ref(true)
  function toggleDarkMode() {
    darkMode.value = !darkMode.value
    // In a real app, you'd persist this preference and apply it to the document
  }
  </script>
  
  <style>
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  .animate-fade-in {
    animation: fadeIn 0.6s ease-out forwards;
  }
  
  .backdrop-blur-sm {
    backdrop-filter: blur(8px);
  }
  
  /* Prose styling for article content */
  .prose {
    color: #d1d5db;
  }
  
  .prose h1,
  .prose h2,
  .prose h3,
  .prose h4 {
    color: #ffffff;
  }
  
  .prose a {
    color: #7dd3fc;
    text-decoration: none;
    font-weight: 500;
  }
  
  .prose a:hover {
    color: #22d3ee;
    text-decoration: underline;
  }
  
  .prose code {
    color: #f472b6;
    font-weight: 500;
    font-size: 0.9em;
  }
  
  .prose pre {
    background-color: rgba(17, 24, 39, 0.7);
    color: #e5e7eb;
    border-radius: 0.5rem;
    padding: 1rem;
    overflow-x: auto;
  }
  
  .prose pre code {
    color: inherit;
    font-weight: normal;
    background-color: transparent;
    padding: 0;
  }
  
  .line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

/* Nuclear fallback (for shadow DOM or extreme cases) */
.custom-html h1 {
  @apply text-4xl font-bold my-6 text-white mt-12;
}
.custom-html h2 {
  @apply text-3xl font-bold my-5 text-white mt-12;
}
.custom-html h3 {
  @apply text-2xl font-semibold my-4 text-white mt-12;
}
.custom-html p {
  @apply text-base my-3 text-gray-300;
}
.custom-html a {
  @apply text-cyan-400 underline hover:text-cyan-300;
}
  </style>